import axios from 'axios';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Config } from '../common/config';
import translations from '../data/translation';
import naegift_eng_logo from '../images/naegift_eng_logo.png';
import naegift_ko_logo from '../images/naegift_ko_logo.png';
import { setLanguage } from '../reducers/languageSlice'; // Redux 액션 임포트
import { userLogout } from '../reducers/userInfo';

export default function Header() {
  const dispatch = useDispatch();
  const userInfo = useSelector(state => state.userInfo);
  const language = useSelector(state => state?.language?.language); // Redux에서 언어 상태 가져오기
  const t = translations[language];

  const logOut = async () => {
    try {
      await axios.post(
        `${Config.API_SERVER}logout`,
        {},
        { withCredentials: true }
      );
    } catch (e) {}
    dispatch(userLogout());
    localStorage.removeItem('user');
    window.location.href = `${Config.SHOPADMIN_SERVER}login`;
  };

  // 언어 변경 함수: Redux 상태 업데이트
  const changeLanguage = () => {
    const newLanguage = language === 'ko' ? 'en' : 'ko';
    dispatch(setLanguage(newLanguage)); // Redux 액션 디스패치
  };

  return (
    <>
      <header>
        <section className="header_box">
          <h1>
            <a href={Config.SHOPMAIN_SERVER}>
              <img
                className="header_logo"
                src={language === 'en' ? naegift_eng_logo : naegift_ko_logo}
                alt="내기프트"
              />
            </a>
          </h1>
          <nav>
            <ul className="header_nav">
              <li>
                <a href={Config.SHOPMAIN_SERVER}>{t.serviceIntro}</a>
              </li>
              <li>
                <a href="/store-guide" style={{ fontWeight: 500, color: '#ff6600' }}>
                  📖 상점가이드
                </a>
              </li>
              <li>
                <a
                  href="https://cafe.naver.com/naegift"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t.storeSupport}
                </a>
              </li>
            </ul>
          </nav>
          <ul className="header_login">
            {userInfo?.id ? (
              <>
                <li onClick={logOut}>{t.logout}</li>
              </>
            ) : (
              <>
                <li>
                  <a href={`${Config.SHOPADMIN_SERVER}login`}>{t.login}</a>
                </li>
                <li>
                  <a href={`${Config.SHOPMAIN_SERVER}user-signup`}>
                    {t.signUp}
                  </a>
                </li>
              </>
            )}
            <li
              onClick={changeLanguage}
              style={{ cursor: 'pointer', marginRight: '20px' }}
            >
              {language === 'ko' ? 'EN' : '한글'}
            </li>
          </ul>
        </section>
      </header>
    </>
  );
}
